import React, { useMemo } from 'react'
import { useEffect, useState } from 'react';
import axios from 'axios';
import AuthUser from './AuthUser';
import toast, { Toaster } from "react-hot-toast";
import { useParams } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { getStudentPhotoUrl } from "../utils/imageUtils";

export default function StudentEdit() {
    const navigate = useNavigate();
    const { http, user } = AuthUser();
    const { id } = useParams();
    const [users, setUsers] = useState([]);
    const [masterdata, setmasterdata] = useState([]);
    const [masterdataIndi, setMasterdataIndi] = useState([]);
    const [cat, setCat] = useState([]);
    const [usersjob, setUsersJob] = useState([]);
    const [loading, setLoading] = useState(true);
    const [standard, setstandard] = useState([]);
    const [devision, setDevision] = useState([]);
    const [agent, setAgent] = useState([]);
    const [location, setLocation] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [headReceiptList, setHeadReceiptList] = useState([]);
    const [years, setYears] = useState([]);

    const [formData, setFormData] = useState({
        adm_no: '',
        assigned_by: user.id,
        adm_date: '',
        gvt_no: '',
        class: '',
        section: '',
        roll_no: '',
        sibling_study: '',
        group_name: '',
        dob: '',
        category: '',
        mobile: '',
        cast: '',
        religion: '',
        adhar: '',
        email: '',
        club: '',
        photo: '',
        father: '',
        mother: '',
        father_occ: '',
        mother_phone: '',
        mother_occu: '',
        guardian_name: '',
        guardian_occu: '',
        guardian_relation: '',
        guardian_phone: '',
        guardian_address: '',
        ext_1: '',
        ext_2: '',
        ext_3: '',
        ext_4: '',
        ext_5: '',
        ext_6: '',
        ext_7: '',
        ext_8: '',
        ext_9: '',
        ext_10: '',
        ext_11: '',
        ext_12: '',
        ext_13: '',
        ext_16: '',
        ext_14: '',
        ext_15: '',
        ext_17: '',
        ext_18: '',
        adhar: '',
        tc_num: '',
        head_receipt: '',
        alpha: '',
        reported: 0,
        revise_agent_id: '',
        year: '',
    });


    const handleChange = (e) => {
        const { name, value } = e.target;
        
        // If head_receipt is changed, auto-populate alpha
        if (name === 'head_receipt') {
            const selectedHeadReceipt = headReceiptList.find(hr => hr.name === value);
            setFormData({
                ...formData,
                [name]: value,
                alpha: selectedHeadReceipt ? selectedHeadReceipt.alpha || '' : ''
            });
        } else if (name === 'year') {
            // Clear class when year changes
            setFormData({
                ...formData,
                [name]: value,
                class: ''
            });
        } else if (name === 'revise_agent_id') {
            // When revise_agent_id changes, also set ext_11 to the agent name
            const selectedAgent = agent.find(a => a.id === parseInt(value));
            setFormData({
                ...formData,
                [name]: value,
                ext_11: selectedAgent ? selectedAgent.name : ''
            });
        } else {
            setFormData({
                ...formData,
                [name]: value
            });
        }

        if (e.target.name === 'category') {
            fetchUsersForDepartment(e.target.value);
        }

        if (e.target.name === 'master_id') {
            fetchMasterIndividual(e.target.value)
        }
    };

    const fetchUsersForDepartment = async (departmentId) => {
        try {
            const response = await http.get(`/master_cat?cat=${departmentId}`);
            setmasterdata(response.data.users);
        } catch (error) {
            console.error("Error fetching users:", error);
        }

    }

    const fetchMasterIndividual = async (msterId) => {
        try {
            const response = await http.get(`/master_cat_indi?cat=${msterId}`);
            setMasterdataIndi(response.data.users);
        } catch (error) {
            console.error("Error fetching users:", error);
        }

    }

    const fetchHeadReceipts = async () => {
        try {
            const response = await http.get(`/head_generals?company_id=${user.company_id}`);
            if (Array.isArray(response.data.data)) {
                setHeadReceiptList(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching head receipts:", error);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await http.get(`/student_marks?&id=${id}&company_id=${user.company_id}`);
                // Simulate a 20-second delay using setTimeout
                setTimeout(() => {
                    setUsersJob(response.data.data);
                    setLoading(false); // Set loading to false after setting the state
                }, 200); // 20 seconds in milliseconds
            } catch (error) {
                console.error("Error fetching data:", error);
                setLoading(false); // Set loading to false in case of an error
            }
        };

        http.get(`/class?login_user=${user.id}&company_id=${user.company_id}`).then((res) => {
            setstandard(res.data.data);
        });

        http.get(`/devision?login_user=${user.id}`).then((res) => {
            setDevision(res.data.data);
        });

        fetchData();

        http.get(`/agent?login_user=${user.id}&company_id=${user.company_id}`).then((res) => {
            setAgent(res.data.data);
        });

        http.get(`/location?login_user=${user.id}&company_id=${user.company_id}`).then((res) => {
            setLocation(res.data.data);
        });

        fetchHeadReceipts();

        http.get(`/year?login_user=${user.id}`).then((res) => {
            setYears(res.data.data);
        });

    }, []);

    useEffect(() => {
        if (usersjob.length > 0) {
            setFormData({
                adm_no: usersjob[0].adm_no || '',
                assigned_by: user.id,
                adm_date: usersjob[0].adm_date || '',
                gvt_no: usersjob[0].gvt_no || '',
                class: usersjob[0].class || '',
                section: usersjob[0].section || '',
                roll_no: usersjob[0].roll_no || '',
                sibling_study: usersjob[0].sibling_study || '',
                group_name: usersjob[0].group_name || '',
                dob: usersjob[0].dob || '',
                category: usersjob[0].category || '',
                mobile: usersjob[0].mobile || '',
                cast: usersjob[0].cast || '',
                religion: usersjob[0].religion || '',
                adhar: usersjob[0].adhar || '',
                email: usersjob[0].email || '',
                club: usersjob[0].club || '',
                photo: usersjob[0].photo || '',
                father: usersjob[0].father || '',
                mother: usersjob[0].mother || '',
                father_occ: usersjob[0].father_occ || '',
                mother_phone: usersjob[0].mother_phone || '',
                mother_occu: usersjob[0].mother_occu || '',
                guardian_name: usersjob[0].guardian_name || '',
                guardian_occu: usersjob[0].guardian_occu || '',
                guardian_relation: usersjob[0].guardian_relation || '',
                guardian_phone: usersjob[0].guardian_phone || '',
                guardian_address: usersjob[0].guardian_address || '',
                ext_1: usersjob[0].ext_1 || '',
                ext_2: usersjob[0].ext_2 || '',
                ext_3: usersjob[0].ext_3 || '',
                ext_4: usersjob[0].ext_4 || '',
                ext_5: usersjob[0].ext_5 || '',
                ext_6: usersjob[0].ext_6 || '',
                ext_7: usersjob[0].ext_7 || '',
                ext_8: usersjob[0].ext_8 || '',
                ext_9: usersjob[0].ext_9 || '',
                ext_10: usersjob[0].ext_10 || '',
                ext_11: usersjob[0].ext_11 || '',
                ext_12: usersjob[0].ext_12 || '',
                ext_13: usersjob[0].ext_13 || '',
                ext_14: usersjob[0].ext_14 || '',
                ext_16: usersjob[0].ext_16 || '',
                ext_15: usersjob[0].ext_15 || '',
                ext_15: usersjob[0].ext_17 || '',
                ext_15: usersjob[0].ext_18 || '',
                adhar: usersjob[0].adhar || '',
                tc_num: usersjob[0].tc_num || '',
                head_receipt: usersjob[0].head_receipt || '',
                alpha: usersjob[0].alpha || '',
                reported: usersjob[0].reported || 0,
                revise_agent_id: usersjob[0].revise_agent_id || '',
                year: usersjob[0].year || '',
            });
        }
    }, [usersjob, user]);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    // Filter classes based on selected year (ext_3 in class table)
    const filteredClasses = useMemo(() => {
        if (!formData.year) return standard;
        return standard.filter((cls) => cls.ext_3 === formData.year);
    }, [standard, formData.year]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        // Validate mandatory fields
        if (!formData.adm_no || formData.adm_no.trim() === '') {
            toast.error("Admission Number is required");
            setIsSubmitting(false);
            scrollToTop();
            return;
        }
        if (!formData.ext_2 || formData.ext_2.trim() === '') {
            toast.error("Name is required");
            setIsSubmitting(false);
            scrollToTop();
            return;
        }
        if (!formData.class || formData.class.trim() === '') {
            toast.error("Class is required");
            setIsSubmitting(false);
            scrollToTop();
            return;
        }
        if (!formData.section || formData.section.trim() === '') {
            toast.error("Section is required");
            setIsSubmitting(false);
            scrollToTop();
            return;
        }
        if (user.status === 1 && (user.department_id === 1 || user.department_id === 3 || user.department_id === 5)) {
            if (!formData.revise_agent_id || formData.revise_agent_id === '') {
                toast.error("Revise Agent is required");
                setIsSubmitting(false);
                scrollToTop();
                return;
            }
        }
        if (!formData.ext_12 || formData.ext_12 === '') {
            toast.error("Transport is required");
            setIsSubmitting(false);
            scrollToTop();
            return;
        }
        if (!formData.year || formData.year === '') {
            toast.error("Year is required");
            setIsSubmitting(false);
            scrollToTop();
            return;
        }
        
        // Create a copy of formData and ensure reported is always included
        const submitData = { ...formData };
        // Explicitly include reported field even if it's 0
        if (submitData.reported === undefined || submitData.reported === null) {
            submitData.reported = 0;
        }

        try {
            await http.put(`/student_edit/${id}`, submitData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            toast.success("Profile data updated successfully !");
            navigate('/student_list_all');
        } catch (error) {
            console.error('Error updating student:', error.response.data);
            setIsSubmitting(false);
        }
    };

    const DropdownOption = ({ user }) => {
        return (
            <option key={user.id} value={user.id}>
                {user.item_name}
            </option>
        );
    };
    if (loading) {
        return <p>Loading...</p>; // You can replace this with a loading spinner or any other loading indicator
    }

    return (
        <>
            <div className="container mt-2 row">
                <Toaster />
                <h3>Student Details</h3>
                <hr />
                <div className="col-md-4 mb-3">
                    {usersjob && usersjob.length > 0 && usersjob[0].photo ? (
                        <img
                            src={getStudentPhotoUrl(usersjob[0].photo)}
                            width="135"
                            height="145"
                            alt="Photo"
                        />
                    ) : (
                        <img src="/dummy.jpg" alt="photo" width="135" height="145" />
                    )}

                </div>
                <form onSubmit={handleSubmit}>
                    <div className='row blue-input-container'>

                        <div className='col-md-4 border p-4 mx-1'>
                            <h4>Personal Details</h4>

                            <div className='form-group mt-3'>
                                <label>Admission Number <span className="text-danger">*</span></label>
                                <input
                                    name="adm_no"
                                    className='form-control'
                                    defaultValue={usersjob[0].adm_no}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Student Type</label>
                                <select className="form-control" name="ext_10" defaultValue={usersjob[0].ext_10}
                                    onChange={handleChange} required>
                                    <option value="">Select Any</option>
                                    <option value="New">New</option>
                                    <option value="Old">Old</option>
                                </select>
                            </div>

                            <div className='form-group mt-3'>
                                <label>Admission Date</label>
                                <input
                                    name="adm_date"
                                    className='form-control'
                                    defaultValue={usersjob[0].adm_date}
                                    onChange={handleChange}
                                    type='date'
                                />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Name <span className="text-danger">*</span></label>
                                <input
                                    name="ext_2"
                                    className='form-control'
                                    defaultValue={usersjob[0].ext_2}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Last Name</label>
                                <input
                                    name="ext_3"
                                    className='form-control'
                                    defaultValue={usersjob[0].ext_3}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Gender</label>
                                <select className="form-control" name="ext_9" defaultValue={usersjob[0].ext_9}
                                    onChange={handleChange}>
                                    <option value="Male">Male</option>
                                    <option value="Fe-Male">Fe-Male</option>
                                </select>
                            </div>

                            <div className='form-group mt-3'>
                                <label>STS Number</label>
                                <input
                                    name="gvt_no"
                                    className='form-control'
                                    defaultValue={usersjob[0].gvt_no}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Year <span className="text-danger">*</span></label>
                                <select
                                    name="year"
                                    className='form-control'
                                    value={formData.year}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Select Year</option>
                                    {years.map((year) => (
                                        <option key={year.id} value={year.name}>
                                            {year.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className='form-group mt-3'>
                                <label>Class <span className="text-danger">*</span></label>
                                <select 
                                    className="form-control" 
                                    name="class" 
                                    value={formData.class}
                                    onChange={handleChange} 
                                    required
                                    disabled={!formData.year}
                                >
                                    <option value="">{formData.year ? 'Select Class' : 'Select Year first'}</option>
                                    {filteredClasses.map((depart) => (
                                        <option key={depart.id} value={depart.class_name}>
                                            {depart.class_name}
                                        </option>
                                    ))}
                                </select>
                                {!formData.year && <small className="text-muted">Please select year first</small>}
                            </div>


                            <div className='form-group mt-3'>
                                <label>Section <span className="text-danger">*</span></label>
                                <select className="form-control" required name="section" defaultValue={usersjob[0].section}
                                    onChange={handleChange}>
                                    <option value="">Select</option>
                                    {devision.map((depart) => (
                                        <option key={depart.id} value={depart.name}>
                                            {depart.name}
                                        </option>
                                    ))}

                                </select>
                            </div>

                            <div className='form-group mt-3'>
                                <label>Roll No</label>
                                <input
                                    name="roll_no"
                                    className='form-control'
                                    defaultValue={usersjob[0].roll_no}
                                    onChange={handleChange}
                                />
                            </div>
                            {(user.status === 1 && (user.department_id === 1 || user.department_id === 3 || user.department_id === 5)) && (
                            <div>
                            {/* <div className='form-group mt-3'>
                                <label>Agent</label>

                                <select name="ext_11"
                                    className='form-control'
                                    defaultValue={usersjob[0].ext_11}
                                    onChange={handleChange} 
                                >
                                    <option value="">Select any</option>
                                    {agent.map((depart) => (
                                        <option key={depart.id} value={depart.name}>
                                            {depart.name}
                                        </option>
                                    ))}
                                </select>

                            </div> */}

                            <div className='form-group mt-3'>
                                <label>Revise Agent <span className="text-danger">*</span></label>
                                <select
                                    name="revise_agent_id"
                                    className='form-control'
                                    value={formData.revise_agent_id}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Select any</option>
                                    {agent.map((depart) => (
                                        <option key={depart.id} value={depart.id}>
                                            {depart.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className='form-group mt-3'>
                                <label>Agent Amount</label>
                                <input
                                    name="ext_17"
                                    className='form-control'
                                    defaultValue={usersjob[0].ext_17}
                                    onChange={handleChange}
                                    type='number'
                                />
                            </div>
                            </div>
                            )}

                            {/* <div className='form-group mt-3'>
                                <label>Agent Extra</label>
                                <input
                                    name="ext_18"
                                    className='form-control'
                                    defaultValue={usersjob[0].ext_18}
                                    onChange={handleChange}
                                />
                            </div> */}


                            <div className='form-group mt-3'>
                                <label>Transport <span className="text-danger">*</span></label>
                                <select className="form-control" name="ext_12" defaultValue={usersjob[0].ext_12}
                                    onChange={handleChange} required>
                                    <option value="">Select Any</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                            </div>

                            <div className='form-group mt-3'>
                                <label>Way</label>
                                <select className="form-control" name="ext_13" defaultValue={usersjob[0].ext_13} onChange={handleChange}>
                                    <option value="">Select Any</option>
                                    <option value="One-Way">One Way</option>
                                    <option value="Two-Way">Two Way</option>
                                </select>
                            </div>

                            <div className='form-group mt-3'>
                                <label>Pickup Location</label>
                                {usersjob.length > 0 && (
                                    <select
                                        name="ext_16"
                                        className='form-control'
                                        defaultValue={usersjob[0].ext_16 || ""}
                                        onChange={handleChange} 
                                    >
                                        <option value="">Select any</option>
                                        {location.map((depart) => (
                                            <option key={depart.id} value={depart.name}>
                                                {depart.name}
                                            </option>
                                        ))}
                                    </select>
                                )}
                            </div>


                            <div className='form-group mt-3'>
                                <label>Previous Class</label>
                                <input
                                    name="ext_14"
                                    defaultValue={usersjob[0].ext_14}
                                    className='form-control'
                                    onChange={handleChange}

                                />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Sibling Studying</label>
                                <input
                                    name="sibling_study"
                                    className='form-control'
                                    onChange={handleChange}
                                    defaultValue={usersjob[0].sibling_study}
                                />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Group Name</label>
                                <input
                                    name="group_name"
                                    className='form-control'
                                    onChange={handleChange}
                                    defaultValue={usersjob[0].group_name}

                                />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Date Of Birth</label>
                                <input
                                    name="dob"
                                    className='form-control'
                                    onChange={handleChange}
                                    defaultValue={usersjob[0].dob}

                                    type='date'
                                />
                            </div>



                            <div className='form-group mt-3'>
                                <label>Category</label>
                                <select
                                    name="category"
                                    className='form-control'
                                    onChange={handleChange}
                                    defaultValue={usersjob[0].category}
                                >
                                    <option value="">Select Category</option>
                                    <option value="A">A</option>
                                    <option value="B">B</option>
                                    <option value="C">C</option>
                                    <option value="D">D</option>
                                    <option value="E">E</option>
                                    <option value="F">F</option>
                                    <option value="G">G</option>
                                    <option value="H">H</option>
                                    <option value="I">I</option>
                                    <option value="J">J</option>
                                    <option value="K">K</option>
                                    <option value="L">L</option>
                                    <option value="M">M</option>
                                    <option value="N">N</option>
                                    <option value="O">O</option>
                                    <option value="P">P</option>
                                    <option value="Q">Q</option>
                                    <option value="R">R</option>
                                    <option value="S">S</option>
                                    <option value="T">T</option>
                                    <option value="U">U</option>
                                    <option value="V">V</option>
                                    <option value="W">W</option>
                                    <option value="X">X</option>
                                    <option value="Y">Y</option>
                                    <option value="Z">Z</option>
                                </select>
                            </div>

                            <div className='form-group mt-3'>
                                <label>Mobile Number</label>
                                <input
                                    name="mobile"
                                    className='form-control'
                                    onChange={handleChange}
                                    defaultValue={usersjob[0].mobile}
                                    required
                                />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Caste</label>
                                <input
                                    name="cast"
                                    className='form-control'
                                    onChange={handleChange}
                                    defaultValue={usersjob[0].cast}
                                />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Caste Category</label>
                                <input
                                    name="ext_15"
                                    className='form-control'
                                    defaultValue={usersjob[0].ext_15}
                                    onChange={handleChange}

                                />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Aadhaar No/UID</label>
                                <input
                                    name="adhar"
                                    className='form-control'
                                    defaultValue={usersjob[0].adhar}
                                    onChange={handleChange}

                                />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Religion</label>
                                <input
                                    name="religion"
                                    className='form-control'
                                    onChange={handleChange}
                                    defaultValue={usersjob[0].religion}

                                />
                            </div>

                            {/* <div className='form-group mt-3'>
                                <label>Aadhaar No/UID</label>
                                <input
                                    name="adhar"
                                    className='form-control'
                                    onChange={handleChange}
                                    defaultValue={usersjob[0].adhar}

                                />
                            </div> */}

                            <div className='form-group mt-3'>
                                <label>Email</label>
                                <input
                                    name="email"
                                    className='form-control'
                                    onChange={handleChange}
                                    defaultValue={usersjob[0].email}

                                />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Other Remark</label>
                                <input
                                    name="club"
                                    className='form-control'
                                    onChange={handleChange}
                                    defaultValue={usersjob[0].club}

                                />
                            </div>

                            {/* <div className="form-group mt-3">
                                <label>Photo</label>
                                <input type="file" className="form-control" name='photo' onChange={handleChange} />
                            </div> */}

                            {/* <div className="form-group mt-3">
                                <label>Adhar</label>
                                <input type="file" name='adhar' className="form-control" onChange={handleChange} />
                            </div> */}

                            {/* <div className="form-group mt-3">
                                <label>Photo</label>
                                {usersjob[0].photo ? (
                                    <img
                                        src={getStudentPhotoUrl(usersjob[0].photo)}
                                        width="135"
                                        height="145"
                                        alt="Photo"
                                    />
                                ) : (
                                    <img src="/dummy.jpg" alt="photo" width="135" height="145" />
                                )}
                            </div> */}
                        </div>

                        <div className='col-md-4 border  p-4 mx-2'>
                            <h4>Parent / Guardian's Details</h4>

                            <div className='form-group mt-3'>
                                <label>Father's Name</label>
                                <input
                                    name="father"
                                    onChange={handleChange}
                                    className='form-control'
                                    defaultValue={usersjob[0].father}

                                />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Father's Phone</label>
                                <input
                                    name="ext_1"
                                    onChange={handleChange}
                                    className='form-control'
                                    defaultValue={usersjob[0].ext_1}

                                />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Father's Occupation</label>
                                <input
                                    name="father_occ"
                                    onChange={handleChange}
                                    className='form-control'
                                    defaultValue={usersjob[0].father_occ}

                                />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Mother's Name</label>
                                <input
                                    name="mother"
                                    className='form-control'
                                    onChange={handleChange}
                                    defaultValue={usersjob[0].mother}

                                />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Mother's Phone</label>
                                <input
                                    name="mother_phone"
                                    onChange={handleChange}
                                    className='form-control'
                                    defaultValue={usersjob[0].mother_phone}

                                />
                            </div>


                            <div className='form-group mt-3'>
                                <label>Mother's Occupation</label>
                                <input
                                    name="mother_occu"
                                    className='form-control'
                                    onChange={handleChange}
                                    defaultValue={usersjob[0].mother_occu}

                                />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Guardian's Name</label>
                                <input
                                    name="guardian_name"
                                    onChange={handleChange}
                                    className='form-control'
                                    defaultValue={usersjob[0].guardian_name}

                                />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Guardian's Relation</label>
                                <input
                                    name="guardian_relation"
                                    onChange={handleChange}
                                    className='form-control'
                                    defaultValue={usersjob[0].guardian_relation}


                                />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Guardian's Occupation</label>
                                <input
                                    name="guardian_occu"
                                    onChange={handleChange}
                                    className='form-control'
                                    defaultValue={usersjob[0].guardian_occu}


                                />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Guardian's Phone</label>
                                <input
                                    name="guardian_phone"
                                    onChange={handleChange}
                                    className='form-control'
                                    defaultValue={usersjob[0].guardian_phone}


                                />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Guardian's Address</label>
                                <textarea name="guardian_address"
                                    className='form-control'
                                    onChange={handleChange}
                                    value={formData.guardian_address}
                                ></textarea>
                            </div>
                            <hr />

                            <div className='border border-success p-3'>

                                <div className='form-group mt-3'>
                                    <label>Current Address</label>
                                    <textarea name="ext_4"
                                        className='form-control'
                                        onChange={handleChange}
                                        defaultValue={usersjob[0].ext_4}
                                    ></textarea>
                                </div>

                                <div className='form-group mt-3'>
                                    <label>Permanent Address</label>
                                    <textarea name="ext_5"
                                        className='form-control'
                                        onChange={handleChange}
                                        defaultValue={usersjob[0].ext_5}
                                    ></textarea>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-3 border  p-2 px-2'>
                            <h4>Miscellaneous Details</h4>

                            <div className='form-group mt-3'>
                                <label>Previous School Details</label>
                                <textarea name="pre_school"
                                    className='form-control'
                                    onChange={handleChange}
                                    defaultValue={usersjob[0].pre_school}

                                >

                                </textarea>
                            </div>

                            <div className='form-group mt-3'>
                                <label>Head</label>
                                <input
                                    name="tc_num"
                                    className='form-control'
                                    onChange={handleChange}
                                    defaultValue={usersjob[0].tc_num}

                                />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Head Receipt</label>
                                <select 
                                    name="head_receipt" 
                                    className='form-control'
                                    value={formData.head_receipt}
                                    onChange={handleChange}
                                >
                                    <option value="">Select Head Receipt</option>
                                    {headReceiptList.map((receipt) => (
                                        <option key={receipt.id} value={receipt.name}>
                                            {receipt.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className='form-group mt-3'>
                                <label>Alpha</label>
                                <input
                                    name="alpha"
                                    className='form-control'
                                    value={formData.alpha}
                                    onChange={handleChange}
                                    readOnly
                                    style={{ backgroundColor: '#e9ecef' }}
                                />
                                <small className="form-text text-muted">Auto-populated from selected Head Receipt</small>
                            </div>

                            <div className='form-group mt-3'>
                                <label>Reported</label>
                                <select 
                                    name="reported"
                                    className='form-control'
                                    value={formData.reported}
                                    onChange={handleChange}
                                >
                                    <option value={0}>No</option>
                                    <option value={1}>Yes</option>
                                </select>
                            </div>
                        </div>

                    </div>
                    <button className="btn button btn-success mt-3" type="submit" disabled={isSubmitting}>
                        {isSubmitting ? 'Updating...' : 'Update'}
                    </button>
                </form>
            </div>
        </>
    )
}
